var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagsIcon = function SvgTagsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10974_27351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48965 6.538L3.41865 10.838C2.92165 11.533 2.92165 12.468 3.41865 13.163L6.48965 17.463C6.86465 17.988 7.47065 18.3 8.11665 18.3H18.9996C20.1046 18.3 20.9996 17.405 20.9996 16.3V7.7C20.9996 6.595 20.1046 5.7 18.9996 5.7H8.11665C7.47065 5.7 6.86465 6.012 6.48965 6.538Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10974_27351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgTagsIcon as ReactComponent };
export default __webpack_public_path__ + "tags-icon.svg";